import { useState } from "react";
import { Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import { Layout } from "antd";
import LayoutHeader from "./layoutHeader";
import ProtectedRoute from "./ProtectedRoute";
import SideBaruser from "./sideBar";
import Accountant from "../accountant/accountant";
import AccountantProfileIndex from "../accountant/profile/profileIndex";
import LeaveDetails from "../accountant/leaveDetails/leaveDetails";
import PayrollDetails from "../accountant/salaryDetails/payrollIndex";
import SalaryPaymentDetails from "../accountant/salaryDetails/salaryPaymentDetails";
import ClientPaymentDetails from "../accountant/salaryDetails/clientPaymentDetails";
import Salary_Details from "../accountant/profile/salary_Details";
import TotalLeaveDetails from "../accountant/leaveDetails/totalLeaveDetails";
import UpdatePayrollDetails from "../accountant/salaryDetails/updatePayrollDetails";
import InternshipPayement from "../accountant/salaryDetails/internship/internshipPayement";
import UpdateInternship from "../accountant/salaryDetails/internship/updateInternship";
import AccountantDashboard from "../accountant/accountant";

const AccountantNavigation = () => {
  const user = useSelector((state: any) => state.user);
  const [collapsed, setCollapsed] = useState(false);
  const { Sider, Content } = Layout;

  return (
    <Layout>
      <Sider
        style={{ backgroundColor: "#FF1A1A", height: "100vh" }}
        trigger={null}
        collapsible
        collapsed={collapsed}
        width={collapsed ? 40 : 250}
      >
        <SideBaruser
          collapsed={collapsed}
          doCollapse={() => setCollapsed(!collapsed)}
        />
      </Sider>
      <Layout>
        <LayoutHeader />
        <Content style={{ background: "#fff" }}>
          <Routes>
            <Route path="/" element={<AccountantDashboard />} />

            <Route
              path="/Accountant_Dashboard"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <AccountantDashboard />
                </ProtectedRoute>
              }
            />

            <Route
              path="/profile"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <AccountantProfileIndex />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Leave_Details"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <LeaveDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Payroll_Details"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <PayrollDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Salary_Details"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <SalaryPaymentDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Client_Payment_Details"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <ClientPaymentDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/viewSalaryDetails"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <Salary_Details />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Total_Leave_Details"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <TotalLeaveDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Payroll_Details/updatePayroll/:id"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <UpdatePayrollDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/internshipPayment"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <InternshipPayement />
                </ProtectedRoute>
              }
            />
            <Route
              path="/internshipPayment/UpdateInternship/:id"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <UpdateInternship />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
};

export default AccountantNavigation;
